module.exports = __webpack_public_path__ + "static/winebox-experience-map-1-ed4a6a4c94d4e7ec599cacbd26bdcc95.jpg";